module.exports = __webpack_public_path__ + "static/media/about-heading.f0a43a62.svg";